/**
 * SectionHeadline + SectionEyebrow — promoted from SecurityCenter.tsx so the
 * three sub-pages (BPA, Secure Score, App Posture) can render the same
 * editorial section pattern without duplicating the markup.
 *
 * Eyebrow: ALL CAPS micro-text. Headline: italic-mixed display type with
 * tone-tinted emphasis (the `[&_em]` selector picks `--tone-accent-deep` from
 * the nearest `[data-tone]` ancestor — usually the section / page wrapper).
 */

import clsx from 'clsx'
import type { ReactNode } from 'react'

export function SectionEyebrow({ text }: { text: string }) {
  return (
    <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-slate-500">
      {text}
    </div>
  )
}

export function SectionHeadline({
  children,
  level = 'page',
}: {
  children: ReactNode
  level?: 'page' | 'card'
}) {
  const sizeClass = level === 'card' ? 'text-[20px]' : 'text-[28px]'
  return (
    <h2
      className={clsx(
        'mt-1 font-display font-extrabold tracking-[-0.018em]',
        sizeClass,
        '[&_em]:italic [&_em]:font-semibold [&_em]:[color:var(--tone-accent-deep)]',
      )}
      style={{ color: 'rgb(var(--color-text-primary))' }}
    >
      {children}
    </h2>
  )
}
